/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ModelCommonResponse,
  ModelCreateProjectRequest,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class CreateProject<
  SecurityDataType = unknown
> extends HttpClient<SecurityDataType> {
  /**
   * @description create project list
   *
   * @tags project
   * @name CreateProjectCreate
   * @summary create project
   * @request POST:/createProject
   */
  createProjectCreate = (
    request: ModelCreateProjectRequest,
    params: RequestParams = {}
  ) =>
    this.request<ModelCommonResponse, any>({
      path: `/createProject`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
